import { apiUrl, fetchJson } from '../../apiBase';

export async function getDay(school, studentId, dateStr) {
  const res = await fetchJson(apiUrl(`/admin/study-logs/${encodeURIComponent(school)}/student/${encodeURIComponent(studentId)}/day/${encodeURIComponent(dateStr)}`));
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function upsertDay(
  school,
  studentId,
  dateStr,
  minutes,
  { parent_phone = '', source = 'admin', raw_text = '', timezone, questions, pages, subjects } = {}
) {
  const res = await fetchJson(apiUrl(`/admin/study-logs/${encodeURIComponent(school)}/student/${encodeURIComponent(studentId)}/day/${encodeURIComponent(dateStr)}`), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ minutes, parent_phone, source, raw_text, timezone, questions, pages, subjects }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function summarizeRange(school, studentId, start, end) {
  const url = apiUrl(`/admin/study-logs/${encodeURIComponent(school)}/student/${encodeURIComponent(studentId)}/range?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`);
  const res = await fetchJson(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function listClassDay(school, className, dateStr) {
  const url = apiUrl(`/admin/study-logs/${encodeURIComponent(school)}/class/${encodeURIComponent(className)}/day/${encodeURIComponent(dateStr)}`);
  const res = await fetchJson(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function listClassRange(school, className, start, end) {
  const params = new URLSearchParams({ start, end });
  const res = await fetchJson(apiUrl(`/admin/study-logs/${encodeURIComponent(school)}/class/${encodeURIComponent(className)}/range?${params}`));
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function deleteDay(school, studentId, dateStr) {
  const res = await fetchJson(apiUrl(`/admin/study-logs/${encodeURIComponent(school)}/student/${encodeURIComponent(studentId)}/day/${encodeURIComponent(dateStr)}`), { method: 'DELETE' });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function listAggregateRange(school, start, end, className) {
  const params = new URLSearchParams();
  params.set('start', start);
  params.set('end', end);
  if (className) params.set('class_name', className);
  const url = apiUrl(`/admin/study-logs/${encodeURIComponent(school)}/aggregate?${params.toString()}`);
  const res = await fetchJson(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function listEngagementSummary(school, { className, weekEnd } = {}) {
  const params = new URLSearchParams();
  if (className) params.set('class_name', className);
  if (weekEnd) params.set('weekEnd', weekEnd);
  const q = params.toString();
  const url = apiUrl(`/admin/study-logs/${encodeURIComponent(school)}/engagement/summary${q ? `?${q}` : ''}`);
  const res = await fetchJson(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function listEngagementStudents(school, { className, weekEnd, filter } = {}) {
  const params = new URLSearchParams();
  if (className) params.set('class_name', className);
  if (weekEnd) params.set('weekEnd', weekEnd);
  if (filter) params.set('filter', filter);
  const q = params.toString();
  const url = apiUrl(`/admin/study-logs/${encodeURIComponent(school)}/engagement/students${q ? `?${q}` : ''}`);
  const res = await fetchJson(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}
